import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>

            <h2 class='text-center mb-3'>Convocation July 2024 - Updates</h2> 
            <Row className='mb-5  mt-5 text-center'>

                <Col md={12}  className="mb-3">
                    <Button className='btn-lg c-fontsize14 me-2'>
                        <a href="https://www.youtube.com/live/8mEU4eWJVHw" target='_blank' className='text-white'  >
                            Youtube streaming 
                            (For External Users)</a></Button>

                </Col>

                {/* <Col md={6} className="mb-3">
                    <Button className='btn-lg c-fontsize14' >
                        <a href="http://live.iittp.ac.in/" target='_blank' className='text-white'  >
                            LAN streaming
                            (For External Users)</a></Button>
                </Col> */}
            </Row>

            <ul className='myulcustarrow c-lineheight2dot5 m-2'>

                <li><Link to="#" target="_self"> Click here to view Convocation Brochure - July 2024 - <span className="glowing-text"><b>Will be updated soon..</b></span></Link></li>
                {/* <li><Link to="https://www.iittp.ac.in/convocation2024/" target="_blank"> For more Details</Link></li> */}
                <li>The 6th Convocation of IIT Tirupati is scheduled on <b style={{ color: "blue" }}>21st July 2024 (Sunday) from 3:30 pm to 5:30 pm</b>. The Chief Guest for the convocation is <b style={{ color: "maroon" }}>Shri Kris Gopalakrishnan ji (Co-Founder of Infosys)</b>. Our Chairman, Board of Governors, <b style={{ color: "maroon" }}>Shri Sajjan Jindal (Chairman & Managing Director, JSW Group)</b> will preside over the ceremony.</li>
                <li>The graduates should report to the institute on <b>20th July, 2024</b>. The convocation kits will be issued from <b>10 am on 20th July</b> and must be collected before <b>10 am on 21st July</b>.</li>
                <li>The Convocation rehearsals will be done on the <b>20th afternoon</b> and also on the <b>21st morning</b> and it is mandatory for all the graduates to attend both the convocation rehearsals. Followed by Convocation rehearsals on the <b>20th afternoon</b> interaction with faculty with High-Tea is arranged.</li>
                <li><b>Google form link for registration for 6th Convocation</b> must be filled before <b>June 30, 2024</b> by all graduating students :<Link to="https://forms.gle/6MmCpZFioPJo9e1B8" target="_blank" className="glowing-text"><b style={{ color: "blue" }}><u>Registration Link</u></b></Link></li>
            </ul>


            
        </div>
    );
}

export default Overview;
